import { FC, useState } from 'react';
import dynamic from 'next/dynamic';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';

import { ButtonFPot } from '@components/shared/buttons/button-fpot/ButtonFPot';
import { IconButton } from '@components/shared/buttons/icon-button/IconButton';
import { UnderlinedButton } from '@components/shared/buttons/underlined-button/UnderlinedButton';
import { Drawer } from '@components/shared/drawer/Drawer';
import { Icon } from '@components/shared/icon/Icon';
import { useCatalogData } from '@contexts/catalog-data';
import { FiltersBar } from '../FiltersBar/FiltersBar';

import classes from './FiltersBarMobile.module.scss';

const SortingSelect = dynamic(() => import('../TopBar/SortingSelect').then((mod) => mod.SortingSelect));

interface IProps {
  withOutFilterBar?: boolean;
}

const FiltersBarMobile: FC<IProps> = ({ withOutFilterBar }) => {
  const router = useRouter();
  const pathName = usePathname();
  const searchParams = useSearchParams();
  const { catalog } = useCatalogData();
  const { totalDocs } = catalog || {};
  const [isFiltersOpen, setIsFiltersOpen] = useState(false);

  function handleFiltersOpen() {
    setIsFiltersOpen((s) => !s);
  }

  const resetFilters = () => {
    router.push(pathName);
  };

  const setSort = (newSort: string) => {
    const params = new URLSearchParams(searchParams.toString());
    const sort = newSort.split('_')[0];
    const sortOrder = newSort.split('_')[1];
    params.set('sortBy', sort);
    if (sortOrder) {
      params.set('sortOrder', sortOrder);
    } else {
      params.delete('sortOrder');
    }
    const url = params.toString();
    router.push(`${pathName}?${url}`);
  };

  return (
    <>
      <div className={classes.filterSortContainer}>
        {!withOutFilterBar ? (
          <IconButton className={classes.filtersToggleBtn} onClick={handleFiltersOpen} ariaLabel="Фільтри">
            <Icon type="filterSettings" size={24} offset={8} />
            <span className={classes.filterLabel}>Фільтри</span>
          </IconButton>
        ) : null}
        <SortingSelect setFilter={setSort} />
      </div>
      <Drawer
        open={isFiltersOpen}
        anchor="top"
        onClose={handleFiltersOpen}
        classes={{
          wrapper: classes.mobileModal
        }}
      >
        <div className={classes.modalHeader}>
          <Icon className={classes.closeModalIcon} type="cross" height={22} width={16} onClick={handleFiltersOpen} />
          <div className={classes.modalTitle}>Фільтри</div>
          <UnderlinedButton label="Скинути все" className={classes.resetFiltersBtn} onClick={resetFilters} />
        </div>
        <FiltersBar />
        <div className={classes.filtersFooter}>
          <div className={classes.totalDocs}>
            <span>Знайдено:</span>
            <span>{totalDocs}</span>
          </div>
          <ButtonFPot label="Показати" onClick={handleFiltersOpen} classNameWrapper={classes.showResult} />
        </div>
      </Drawer>
    </>
  );
};

export default FiltersBarMobile;
